import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const FAQS = [
  { q: 'O Raio-X da Marca é mesmo gratuito?', a: 'Sim. É a forma que eu tenho de mostrar, na prática, como penso o seu negócio. Você recebe o diagnóstico e decide se quer seguir comigo. Sem compromisso.' },
  { q: 'O que exatamente eu recebo em 24h?', a: 'Uma análise direta do seu perfil e da sua imagem: o que está funcionando, o que está afastando clientes e as primeiras ações para crescer. Tudo em linguagem simples, no seu WhatsApp.' },
  { q: 'Vocês fazem vídeo, Instagram, site e anúncios?', a: 'Fazemos tudo isso, mas como parte de uma estratégia. Primeiro entendemos onde a sua marca precisa chegar. Depois escolhemos as ferramentas certas para levar você até lá.' },
  { q: 'Atendem fora de Foz do Iguaçu?', a: 'Sim. Estratégia, sites e gestão de presença atendemos em todo o Brasil. Produções audiovisuais presenciais são combinadas conforme o projeto.' },
];

export const BrandFAQ = () => (
  <section id="duvidas" className="py-28 sm:py-36 bg-[var(--br-bg-2)]" data-testid="brand-faq">
    <div className="mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-[0.8fr_1.2fr] gap-12">
      <div>
        <p className="br-mono text-[11px] text-[var(--br-teal)]">Dúvidas</p>
        <h2 className="mt-5 text-3xl sm:text-5xl font-semibold">Antes de <span className="italic text-white/60">conversarmos.</span></h2>
      </div>
      <Accordion type="single" collapsible className="border-t border-white/10">
        {FAQS.map((f, i) => (
          <AccordionItem key={f.q} value={`faq-${i}`} className="border-white/10">
            <AccordionTrigger className="py-6 text-lg sm:text-xl font-semibold hover:no-underline hover:text-[var(--br-teal)] transition-colors" data-testid={`brand-faq-trigger-${i}`}>{f.q}</AccordionTrigger>
            <AccordionContent className="text-base text-[var(--br-muted)] leading-relaxed pr-6" data-testid={`brand-faq-answer-${i}`}>{f.a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
